import { startOfMonth, startOfYear, subDays, subMonths, subYears } from 'date-fns';
import React from 'react';
import { allStatuses } from '../constants';
export const useTimeTrackingFilters = () => {
    const [activeFilters, setActiveFilters] = React.useState([]);
    const applyFilter = (column, value) => {
        const currentDate = new Date();
        const startOfThisMonth = startOfMonth(currentDate).getTime();
        const startOfLastMonth = startOfMonth(subMonths(currentDate, 1)).getTime();
        const startOfLast90Days = subDays(currentDate, 90).getTime();
        const startOfThisYear = startOfYear(currentDate).getTime();
        const startOfLastYear = startOfYear(subYears(currentDate, 1)).getTime();
        const filters = activeFilters.filter((f) => 'column' in f && f.column !== column);
        if (column === 'shiftStartTime') {
            switch (value) {
                case 'thisMonth':
                    filters.push({ column, op: '>=', value: startOfThisMonth });
                    break;
                case 'lastMonth':
                    filters.push({ column, op: '>=', value: startOfLastMonth });
                    filters.push({ column, op: '<', value: startOfThisMonth });
                    break;
                case 'last90Days':
                    filters.push({ column, op: '>=', value: startOfLast90Days });
                    break;
                case 'thisYear':
                    filters.push({ column, op: '>=', value: startOfThisYear });
                    break;
                case 'lastYear':
                    filters.push({ column, op: '>=', value: startOfLastYear });
                    filters.push({ column, op: '<', value: startOfThisYear });
                    break;
            }
        }
        else if (column === 'hoursStatus' && value !== allStatuses) {
            filters.push({ column, op: '=', value });
        }
        setActiveFilters(filters);
    };
    const clearFilters = () => {
        setActiveFilters([]);
    };
    return {
        activeFilters,
        applyFilter,
        clearFilters,
    };
};
